import type { SVGProps } from 'react';
const SvgPlusBlueWithoutBackground = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M8.536 1.572H7.464q-.143 0-.143.143v5.607h-5.32q-.144 0-.144.143v1.072q0 .142.143.142h5.321v5.608q0 .142.143.142h1.072q.142 0 .142-.142V8.679H14q.143 0 .143-.142V7.465q0-.143-.143-.143H8.678V1.715q0-.143-.142-.143"
    />
  </svg>
);
export default SvgPlusBlueWithoutBackground;
